/****************************************************************************************
 *  Copyright (C) 2018 Rising Empire Technologies, Inc - All Rights Reserved
 *  Unauthorized use, modification or distribution of this work is strictly prohibited.
 *  Note: This library can be modified and use within the Details Flowers Software.
 ****************************************************************************************/
var BetterButtons = {
    btnSelector: ".betterBtn",
    icons: true,
    disable: function(button) {
        button = button instanceof jQuery.Event ? $(this) : $(button);

        // Check if already disabled
        if (button.prop("disabled")) return;

        // Disable Button
        button.prop("disabled", true);

        // Capture original text
        var originalText = button.html();
        button.attr("original-text", originalText);

        // Get waiting text
        var message = button.attr("wait-text");
        message = typeof message === "undefined" ? "Please wait..." : message;

        // Get icon
        if (BetterButtons.icons) {
            var icon = button.attr("wait-icon");
            icon = typeof icon === "undefined" ? "fa-spinner fa-spin" : icon;
            message = "<i class=\"fas " + icon + " fa-fw\"></i> &nbsp; " + message;
        }

        // Set message
        button.html(message);
    },
    enable: function(button){
        if (typeof button === "undefined"){
            button = this;
        }
        else {
            button = button instanceof jQuery ? button : $(button);
        }

        if (!button.prop("disabled")) return;

        // Enable Button
        button.prop("disabled", false);

        var originalText = button.attr("original-text");
        button.html(originalText);
    },
    init: function(selector, icons){
        BetterButtons.icons = typeof icons === "undefined" ? true : icons;

        selector = typeof selector === "undefined" ? BetterButtons.btnSelector : selector;
        listen(selector, "click", BetterButtons.disable);
    }
};

// Enable Button: $(selector).betterBtn("enable");
// Disable Button: $(selector).betterBtn("disable");
jQuery.fn.betterBtn = function(option){
    $(this).each(function(){
        var button = this;
        option = option.toLowerCase();
        if (option === "enable" || option === "disable"){
            setTimeout(function(){
                option === "enable" ?
                    BetterButtons.enable(button) : BetterButtons.disable(button);
            }, 0);
        }
    });
    return this; // Preserve the jQuery chainability
};